import React from "react";
import { Link } from "react-router-dom";

import { API_PROMO_MATERIALS_GET_STATIC } from "~/config";
import type { TPromoMaterial } from "./promo_materials_page";

import img from "../manuals/default_thumbnail.png";

const ITEM_TYPE_FILE = 1;
const ITEM_TYPE_MODULE = 2;
const SOURCE_TYPE_URL = 2;

const cardStyle: React.CSSProperties = {
  display: "flex",
  width: "100%",
  minWidth: 0,
  maxWidth: "200px",
  marginLeft: "auto",
  marginRight: "auto",
  backgroundColor: "#ffffff",
  alignItems: "center",
  textAlign: "center",
  flexDirection: "column",
  marginBottom: "10px",
  cursor: "pointer",
  overflow: "visible",
  animation: "fadeInUp 0.5s ease-out",
  position: "relative",
};

const imgStyle: React.CSSProperties = {
  width: "130px",
  height: "130px",
  objectFit: "cover",
  backfaceVisibility: "hidden",
  WebkitBackfaceVisibility: "hidden",
  display: "block",
};

const textStyle: React.CSSProperties = {
  marginTop: "5px",
  padding: "0 8px",
  fontSize: "14px",
  fontWeight: 500,
  color: "#333",
  transition: "color 0.3s ease",
};

const linkStyle: React.CSSProperties = {
  textDecoration: "none",
  color: "inherit",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
};

export default function PromoMaterialsCard({ 
  material, 
  index = 0 
}: { 
  material: TPromoMaterial;
  index?: number;
}) {
  const [hover, setHover] = React.useState(false);

  const thumbnailUrl = API_PROMO_MATERIALS_GET_STATIC("thumbnail", material.promo_material_id);

  const isFile = material.item_type === ITEM_TYPE_FILE;
  const isModule = material.item_type === ITEM_TYPE_MODULE;

  const viewUrl = isFile
    ? material.source_type === SOURCE_TYPE_URL
      ? material.url!
      : API_PROMO_MATERIALS_GET_STATIC("document", material.promo_material_id)
    : null;

  const modulePath = isModule ? material.module_path || "#" : null;

  const thumbAndTitle = (
    <>
      <div className={`pic promo-materials-thumb ${hover ? "promo-materials-thumb--hover" : ""}`}>
        <img
          className="promo-materials-thumb__img"
          src={thumbnailUrl}
          style={imgStyle}
          onError={(e) => {
            (e.target as HTMLImageElement).onerror = null;
            (e.target as HTMLImageElement).src = img;
          }}
          alt=""
        />
      </div>
      <div className="text" style={textStyle}>
        {material.title}
      </div>
    </>
  );

  const cardStyleMerged = {
    ...cardStyle,
    animationDelay: `${index * 0.1}s`,
  };

  if (isModule && modulePath) {
    return (
      <div
        style={cardStyleMerged}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <Link to={modulePath} style={linkStyle}>
          {thumbAndTitle}
        </Link>
      </div>
    );
  }

  if (isFile && viewUrl) {
    return (
      <div
        style={cardStyleMerged}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <a
          href={viewUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          {thumbAndTitle}
        </a>
      </div>
    );
  }

  return null;
}
